import { useAuth } from "../../hooks";
import { Button } from "../ui/button";
import React, { useEffect } from "react";
import { PassportUpload } from "../../api";
import ButtonLoader from "../Loader";
import { setSession } from "../../axios.config";

function RegisterForm4({ imagePreview, setStateVariable, stateVariable }) {
  const {
    imageFile,
    setErrorMessage,
    setIsSubmitting,
    isSubmitting,
    errorMessage,
    handleImageUpload,
    isPdf,
    setIsPdf,
    pdfUrl,
    setPdfUrl,
  } = useAuth();

  useEffect(() => {
    setErrorMessage("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (imageFile) {
      const isPdfFile = imageFile.type === "application/pdf";
      setIsPdf(isPdfFile);
      if (isPdfFile) {
        const objectUrl = URL.createObjectURL(imageFile);
        setPdfUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageFile]);

  const handleSubmit = async () => {
    if (!imageFile) {
      setErrorMessage("Please upload a passport image");
      return;
    }

    // Create form data for API submission
    const formData = new FormData();
    formData.append("file", imageFile);
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const passportUploadResponse = await PassportUpload("front", formData);
      if (passportUploadResponse?.data) {
        setSession("userId", passportUploadResponse?.data?.userData);
        setStateVariable(stateVariable + 1);
      }
    } catch (error) {
      setErrorMessage(error?.message || "Failed to upload passport");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to render appropriate preview based on file type
  const renderPreview = () => {
    if (!imagePreview && !pdfUrl) return null;

    if (isPdf && pdfUrl) {
      return (
        <div className="w-full h-56 flex flex-col items-center justify-center bg-gray-100 rounded-md mb-4">
          <object data={pdfUrl} type="application/pdf" className="w-full h-52">
            <div className="text-center p-4">
              <p className="text-gray-600">
                Your browser doesn't support PDF preview.
              </p>
              {/* <a
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                Open PDF
              </a> */}
            </div>
          </object>
          <div className="text-sm text-gray-500 mt-1">
            {imageFile?.name}{" "}
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline"
            >
              Open PDF
            </a>
          </div>
        </div>
      );
    }

    return (
      <img
        src={imagePreview}
        alt="Passport Front Page"
        className="w-full h-48 object-cover rounded-md mb-4"
      />
    );
  };

  return (
    <>
      <div className="w-full">
        <div className="flex mb-[5px] justify-between">
          <h1 className="text-[26px] font-geomanistMedium text-blackish leading-[34px]">
            Almost done
          </h1>
        </div>
        <p className="text-[16px] mb-[36px] text-greyish font-geomanistRegular">
          Make sure your details are clear and unobstructed.
        </p>
        <div className="flex flex-col items-center">
          <div className="mb-6 mx-auto w-full max-w-[400px]">
            {renderPreview()}
            {errorMessage && (
              <div className="text-red-600 text-center mb-4">
                {errorMessage}
              </div>
            )}
          </div>
          <div className="w-[300px] mx-auto md:w-[400px] flex flex-col md:flex-row md:justify-center gap-3">
            <Button
              variant="outline"
              className="px-10 bg-blueish py-[10px] rounded-lg border-blueish leading-[20px] text-[14px]"
            >
              <label htmlFor="file-upload" className="cursor-pointer">
                <input
                  id="file-upload"
                  type="file"
                  accept="image/jpeg, image/jpg, image/png, application/pdf"
                  className="sr-only"
                  onChange={handleImageUpload}
                />
                Upload again
              </label>
            </Button>
            <Button
              className="px-10 bg-blueish text-white py-[10px] rounded-lg font-geomanistMedium leading-[23px] text-[18px]"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting && <ButtonLoader className="mr-2" />}
              {isSubmitting ? "Uploading..." : "Submit Passport"}
            </Button>
          </div>
          <div
            onClick={() => setStateVariable(stateVariable - 1)}
            className="text-blackShade mt-[12px] font-geomanistMedium text-[18px] leading-[24px] underline hover:cursor-pointer"
          >
            Back
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterForm4;
